import { render } from "./RulesModal.vue?vue&type=template&id=84ddd04a&scoped=true"
import script from "./RulesModal.vue?vue&type=script&lang=js"
export * from "./RulesModal.vue?vue&type=script&lang=js"

import "./RulesModal.vue?vue&type=style&index=0&id=84ddd04a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84ddd04a"]])

export default __exports__